/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/* eslint-disable camelcase */
export type Item = {
  brand?: string;
  category?: string;
  creative_name?: string;
  creative_slot?: string;
  id?: string;
  location_id?: string;
  name?: string;
  price?: number;
  quantity?: number;
};

export type ClickEvent = {
  value?: number;
  items?: Item[];
};

const AddToCartEvent = ({ value, items }: ClickEvent) => {
  window.gtag('event', 'add_to_cart', {
    currency: 'JPY',
    value,
    items,
  });
};

export default AddToCartEvent;
